import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi, getStoredAuth, setStoredAuth, setAuthFailureHandler } from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setAuthFailureHandler(() => setUser(null));
    return () => setAuthFailureHandler(null);
  }, []);

  useEffect(() => {
    const auth = getStoredAuth();
    if (auth?.token && auth?.user) {
      authApi.getProfile()
        .then((r) => {
          setUser(r.data);
          setStoredAuth(auth.token, r.data);
        })
        .catch(() => {
          setStoredAuth(null, null);
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password, otp) => {
    const { data } = await authApi.login(email, password, otp);
    setStoredAuth(data.token, data.user);
    setUser(data.user);
    return data;
  };

  const sendLoginOtp = async (email, password) => {
    await authApi.sendLoginOtp(email, password);
  };

  const signupCustomer = async (payload) => {
    await authApi.signupCustomer(payload);
  };

  const verifySignupOtp = async (email, otp) => {
    const { data } = await authApi.verifySignupOtp(email, otp);
    setStoredAuth(data.token, data.user);
    setUser(data.user);
    return data;
  };

  const updateProfile = async (payload) => {
    const { data } = await authApi.updateProfile(payload);
    setUser(data);
    setStoredAuth(getStoredAuth()?.token, data);
    return data;
  };

  const logout = () => {
    setStoredAuth(null, null);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        sendLoginOtp,
        signupCustomer,
        verifySignupOtp,
        updateProfile,
        logout,
        isLoggedIn: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
